import * as translations from "flavours/app-remind.me/i18n/validation.json";
import { isNumber, isNumberWithoutDots } from "Commons/Utilities/Number";

export const composeValidators = (...validators) => (value) =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const required = (value) => (value ? undefined : translations.isPresent);

export const requiredZeroAccepted = (value) => (value === 0 || value ? undefined : translations.isPresent);

export const mustBeNumber = (value) => {
  return !isNumber(value) ? translations.isNumber : undefined;
};

export const mustBeIntegerNumber = (value) => {
  return !isNumberWithoutDots(value) ? translations.isNumberWithoutCommaDots : undefined;
};

export const isPostalCode = (value) => (/^[0-9]{5}$/.test(value) ? undefined : translations.invalidPostalCode);

export const isNumberSmallerThan = (value) => {
  return function isActuallySmallerThan(actValue) {
    return actValue <= value ? undefined : translations.isNumberTooHigh;
  };
};

export const isTrue = (value) => (value ? undefined : translations.invalidPostalCode);
